import React from 'react';
import styled from 'styled-components';

import { AllCountriesOption } from '@lt/api/dist/methods/references/types';
import { SubtitleBlock, TitleBlock } from '../styles';

export const AllCountryOption = ({ label, iso2, visa, budget, closed }: AllCountriesOption) => (
  <CountryItem $closed={closed}>
    <TitleBlock>
      <FlagContainer>
        <StyledFlag className={`lt-flag lt-flag-${iso2?.toLowerCase()}`} />
      </FlagContainer>
      <div>
        <CountryLabelText>{label}</CountryLabelText>
        <div>
          <SubtitleBlock $active={visa !== 'Без визы'}>{visa}</SubtitleBlock>
          <SubtitleBlock>{'$'.repeat(budget)}</SubtitleBlock>
        </div>
      </div>
    </TitleBlock>
  </CountryItem>
);

const CountryItem = styled.div<{ $closed: boolean }>`
  padding-top: 4px;

  ${({ $closed }) =>
    $closed &&
    `
    opacity: 0.3;
  `}
`;

const CountryLabelText = styled.div`
  font-size: 16px;
  line-height: 20px;
`;

const FlagContainer = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
`;

const StyledFlag = styled.div`
  margin: 0 8px;
`;
